export default __webpack_public_path__ + "static/media/phone-solid.253b1d89.svg";